import React, { useEffect, useState } from "react";
import { FxmsData } from "../datas/FxData";
import { FxResource } from "../inputs/FxResource";
import { FxWindow ,FxmsPopup } from "../windows/FxWindows";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TreeItem from '@mui/lab/TreeItem';

export const FxTreeMenu = props => {
  const [menuList, setMenuList] = useState({}); 
  const [popOpObj, setPopOpObj] = useState({});
  const [popOpen,setPopOpen] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [contextMenuList, setContextMenuList] = useState([]); 
  const [contextMenuXy, setContextMenuXy] = React.useState(null,
    {
      mouseX: 0,
      mouseY: 0
    });

  let moDetailOpObj = FxmsData.getOpObj("ui-4-2-detail"); //TODO 상세보기팝업 FxMoDetail (현재 opid등록 안되어 ui-mo로 적용함-> FxMoDetail로 수정 필요 )
  let psidDetailOpObj = FxmsData.getOpObj("ui-4-2-value-detail"); //TODO 상세보기팝업 FxValueDetail (현재 opid등록 안되어 ui-mo로 적용함-> FxValueDetail로 수정 필요 )
  let moPopOpObj = FxmsData.getOpObj("ui-mo-create"); /*관리대상 추가*/
  let inloPopOpObj = FxmsData.getOpObj("ui-inlo-create"); /*위치 추가*/

  async function getMenuData() {
    const res = await FxmsData.GET("/fxMo/tree/list", {});
    try {
      let data = res.data;

      setMenuList(data);

    } catch (error) {
      console.log("error" + error);
      FxWindow.alert("조회중 오류가 발행되었습니다.", true);
    }
  }
  
   /*context메뉴 관련 기능*/
  const handleContextMenu = (event, data, parent) => {
    event.preventDefault();
    event.stopPropagation()   

    data["parentNode"] = parent;
    data["upperInloNo"] = data.dataId;

    setSelectedData(data); // 팝업으로 넘겨줄 데이터

    /* dataClass='MO'이면 "상세보기" .FxMoDetail
      dataClass='PSID'이면 "상세보기"  FxValueDetail
      dataClass='INLOPOOL'이면 "위치추가＂
      dataClass='MOPOOL'이면 "관리대상 추가" */
    let list = [];     
    if(data.dataClass==='MOPOOL') list.push(<MenuItem sx={{ color: "white" }} onClick={()=>onClick(data.dataClass)}>관리대상추가</MenuItem>);
    else if(data.dataClass==='INLOPOOL') list.push(<MenuItem sx={{ color: "white" }} onClick={()=>onClick(data.dataClass)}>위치추가</MenuItem>);
    else if(data.dataClass==='MO'||data.dataClass==='PSID') list.push(<MenuItem sx={{ color: "white" }} onClick={(event)=>{onClick(data.dataClass);}}>상세보기</MenuItem>);
    else return;

    setContextMenuList(...list);
   
    setContextMenuXy(
      contextMenuXy === null
        ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 }
        : null,
    );       
  };

  const handleClose = () => { 
     setContextMenuXy(null);
  };

  const onClick = (dataClass) => {    
    if(dataClass=='MOPOOL') setPopOpObj(moPopOpObj);
    if(dataClass==='INLOPOOL') setPopOpObj(inloPopOpObj);   
    if(dataClass==='MO') setPopOpObj(moDetailOpObj);
    if(dataClass==='PSID') setPopOpObj(psidDetailOpObj);      
    setPopOpen(true);    

    setContextMenuXy(null);
  };

  const getTreeItems = (data, inhtml) => {
    if(data == undefined){ 
      return inhtml;
    }else{
      let inhtml = [];
      inhtml = getchildrenItems(data[0], inhtml);
      return inhtml;
    }          
  };

  const getchildrenItems = (node, parent) => {
    return (
      <TreeItem key={node.treeId} nodeId={node.treeId + "_" + node.data.dataClass} dataid={node.data.dataId} label={node.data.dataText} onContextMenu={(e) => handleContextMenu(e, node.data, parent)}>
        {node.hasOwnProperty("children") ? node.children.map((item) => getchildrenItems(item, node.data)) : <></>}
      </TreeItem>);
  }

  const closePop = () => {
    setPopOpen(false);
  }

  const onNodeSelect = (e, nodeId) => {
    // console.log(nodeId);  
  };
  
  useEffect(() => {
    getMenuData();    
  }, []);

  return (
    <>
    <TreeView
      aria-label="multi-select"
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      onNodeSelect = {onNodeSelect}
      sx={{ height: 900, flexGrow: 1, maxWidth: 500, overflowY: 'auto' }}
    >
      {Object.keys(menuList).length !== 0? getTreeItems(menuList.trees):<></>}
      <Menu
        open={contextMenuXy !== null}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenuXy !== null
            ? { top: contextMenuXy.mouseY, left: contextMenuXy.mouseX }
            : undefined
        }   
      >
        {contextMenuList}    
      </Menu>
    </TreeView>

     <FxmsPopup open={popOpen} closeModal={closePop} dialogTitle={popOpObj.opTitle} opObj={popOpObj}>
       <FxResource menu={popOpObj} selectedData = {selectedData}/>
    </FxmsPopup>

    </>    
    
  );
}